import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const DeleteAgentConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-agent-modal-wrapper"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Delete Agent?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="delete-confirmation-modal-body">
          <div className="my-3">
            <ul>
              <li>
                This won't affect previously compiled reports, but will apply to
                existing jobs with this agent.
              </li>
              <li>This action cannot be undone.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-0">
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteAgentConfirmationModal;
